export const throwCurrentBuildStatus = () => {
  const MODE = import.meta.env.MODE
  const HOST = import.meta.env.VITE_API_HOST
  const isDev = HOST.includes("dev")
  console.log(`%cBuild mode ${MODE}`, `color: ${MODE === "development" ? "Crimson" : "CornflowerBlue"}`)
  console.log(`%c${isDev ? "Development" : "Production"} api used`, `color: ${isDev ? "Crimson" : "Chartreuse"}`)
}
